import React, { useEffect } from 'react';

import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import {
  individual_column_style,
  individual_header_style
} from '../../../../../../../../assets/styles/table_custom_style';

import './styles.css';
import { toBrazilianFullDate } from 'views/CRM/shared/utils/date';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import { useRecordTypesByUser } from 'views/RecordType/hooks/useRecordTypesByUser';

import { maskCpf } from 'views/CRM/shared/utils/cpfCnpjHelpers';
import { maskCnpj } from 'views/CRM/shared/utils/cpfCnpjHelpers';
import { formatCurrency } from 'utils/fuctions/formatCurrency';
import { useHistory } from 'react-router-dom';
import FlexTable from 'components/FlexTable';
import { PhoneCell } from 'components/FlexTable/components/cells/phone';

const NotPurchasedReportTable = ({
  accounts,
  customFields,
  setSortConfig,
  sortConfig
}) => {
  const { getRecordTypesByUser } = useRecordTypesByUser(entitiesName.ACCOUNT);

  const history = useHistory();

  const navigateToEditAccountPage = (account) => {
    history.push({
      pathname: `/admin/crm/accounts/${account.recordTypeId}/${account.id}`,
      state: {
        from: 'NotPurchasedReport'
      }
    });
  };

  const editContact = (contact) => {
    history.push(
      `/admin/crm/contactForm/${contact.recordTypeId}/${contact.id}`
    );
  };

  useEffect(() => {
    getRecordTypesByUser();
  }, [getRecordTypesByUser]);

  const createDynamicColumns = () => {
    const columns = [];

    columns.push(
      {
        dataField: `account_name`,
        text: 'Conta',
        sort: true,
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_, row) => {
          return (
            <span
              className="account-name"
              onClick={() => {
                navigateToEditAccountPage(row);
              }}
            >
              {row[`Nome`]}
            </span>
          );
        }
      },
      {
        dataField: `account_phone`,
        text: 'Telefone da conta',
        style: individual_column_style,
        formatter: (_, row) => {
          if (!row['Telefone']) return null;
          return <PhoneCell phone={row['Telefone']} ddi={row['DDI Conta']} />;
        }
      },
      {
        dataField: `contact_name`,
        text: 'Contato',
        sort: true,
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_, row) => {
          return (
            <span
              className="account-name"
              onClick={() => {
                editContact(row);
              }}
            >
              {row[`Nome do contato`]}
            </span>
          );
        }
      },
      {
        dataField: `contact_phone`,
        text: 'Telefone do contato',
        style: individual_column_style,
        formatter: (_, row) => {
          if (!row['Telefone do contato']) return null;
          return (
            <PhoneCell
              phone={row['Telefone do contato']}
              ddi={row['DDI Contato']}
            />
          );
        }
      },
      {
        dataField: `contact_email`,
        text: 'E-mail',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, row) => row['E-mail']
      },
      {
        dataField: `amount`,
        text: 'Valor',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, row) => row['Valor']
      },
      {
        dataField: `closed_at`,
        text: 'Data de fechamento',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, row) => {
          if (row['Data de fechamento'] === '-') {
            return '-';
          } else {
            return toBrazilianFullDate(row['Data de fechamento']);
          }
        }
      }
    );

    (customFields || []).forEach((field) => {
      columns.push({
        dataField: field.name,
        text: field.label,
        style: individual_column_style,
        formatter: (_, row) => {
          if (field.type === 'DATE' && !!row[field.name]) {
            return new Date(row[field.name]).toLocaleDateString('pt-br');
          } else if (field.type === 'TELEPHONE' && row[field.name]) {
            return (
              <PhoneCell
                phone={row[field?.name].number}
                ddi={row[field?.name]?.ddi}
              />
            );
          } else if (field.type === 'CPF' && row[field.name]) {
            return maskCpf(row[field.name]);
          } else if (field.type === 'CNPJ' && row[field.name]) {
            return maskCnpj(row[field.name]);
          } else if (field.type === 'CURRENCY' && row[field.name]) {
            return formatCurrency(row[field.name]);
          }
          return row[field.name];
        }
      });
    });

    return columns;
  };

  const dynamicFunctionColumns = createDynamicColumns();
  return (
    <>
      <ToolkitProvider
        data={accounts || []}
        keyField="id"
        columns={dynamicFunctionColumns}
      >
        {(props) => (
          <div className="py-4 table-responsive">
            <FlexTable
              {...props.baseProps}
              classes="align-items-center"
              setSortConfig={setSortConfig}
              sortConfig={sortConfig}
              entityName="notPurchased"
            />
          </div>
        )}
      </ToolkitProvider>
    </>
  );
};

export default NotPurchasedReportTable;
